var rich_content_viewer_default = {
  "fontElementMap": "BtVbl",
  "wrapper": "_6eVkP",
  "pluginContainerMobile": "Tug94",
  "viewer": "_0iKW-",
  "android": "k-Jru",
  "rootedTraversedContent": "HqES-",
  "atomic": "jgTHV",
  "toolbar": "_8NbfR",
  "block": "M6Bqo"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
